import { Pipe, PipeTransform } from "@angular/core";
import { EventContentDto, EventDto } from "@api";
import RRule from "rrule";

@Pipe({ name: "filterEvents" })
export class FilterEventsPipe implements PipeTransform {
  public transform(event: EventDto, searchTerm: string, module: string, eventContent: EventContentDto): boolean {
    if (!event) return false;

    const eventNextExecution = event.recurrence ? RRule.fromString(event.recurrence).after(new Date()) : new Date(event.date);
    eventNextExecution.setMinutes(eventNextExecution.getMinutes() + eventContent?.duration ?? 0);

    if (eventNextExecution.getTime() < Date.now()) return false;

    return (
      (!searchTerm || eventContent.title.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (!module || eventContent.learningModules.some(learningModule => learningModule.id === module))
    );
  }
}
